/*
// KJR 2014-08-22
// Global JS included on every page.  Add all your common script inits here.
*/

//$(document).ready(function() {
$(function() { // Shorthand for $( document ).ready()
	// executes when HTML-Document is loaded and DOM is ready

	//fix for Windows Phone 8
	if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
		var msViewportStyle = document.createElement('style');
		msViewportStyle.appendChild(
			document.createTextNode(
				'@-ms-viewport{width:auto!important}'
			)
		);
		document.querySelector('head').appendChild(msViewportStyle);
	}

	//menu toggle
	$( "#menu_toggle" ).click(function() {
		$('.height').find('.menu_open').removeClass('menu_open').siblings('.drop').removeClass('drop_open');

		$('.topnav').toggleClass( 'height' );
		$('#hamburger').toggleClass('open');
	});

	//track phone number taps & clicks
	$('.tel').on('click', function(e){
		e.preventDefault();
		trackEvent('Mobile', 'Click to Call', $(this).data('tel'));
		window.location = $(this).attr("href");
	});
	
	//animate the scroll to top
	addScrollToOnClick('.back2top', 'body', 500);

	//Check for dropdowns when mobile menu toggle is visible then disable the anchor link for the parent li
	$('.topnav a').click(function(event) {
		event.preventDefault();
		if ($(this).hasClass('has_dropdown') && $('#menu_toggle').is(':visible')) {
			if($(this).hasClass('menu_open')) {
				$('.drop_open').removeClass('drop_open');
				$('.menu_open').removeClass('menu_open');
			}
			else {
				$('.drop_open').removeClass('drop_open');
				$('.menu_open').removeClass('menu_open');
				$(this).addClass('menu_open').siblings('.dropdown-section').find('.drop').addClass('drop_open');
			}
		}
		else if ($(this).get(0).href !== undefined){
			$(location).attr('href', $(this).get(0).href);
		}
	});

	//decrypt encrypted mailto links
	$('.mailto').each(function() {
		var strEncrypted = $(this).html();
		var parts = strEncrypted.split("|");
		var email = rot13(decodeBase64(parts[0]));
		var display = rot13(decodeBase64(parts[1]));
		var html = '<a class="email" href="mailto:'+email+'">'+display+'</a>';
		$(this).html(html);
	});

	//decrypt encrypted mailto links
	$('.hrefto').each(function() {
		var strEncrypted = $(this).attr('href');
		var parts = strEncrypted.split("|");
		var email = rot13(decodeBase64(parts[0]));
		var display = rot13(decodeBase64(parts[1]));
		// var html = '<a class="email" href="mailto:'+email+'">'+display+'</a>';
		$(this).attr('href', 'mailto:' + email);
		$(this).html(display);
	});
	$('#footer_contact_us').active_label();

	$(".megamenu").accessibleMegaMenu({
		uuidPrefix: "accessible-megamenu",
		menuClass: "nav-menu",
		topNavItemClass: "nav-item",
		panelClass: "sub-nav",
		panelGroupClass: "sub-nav-group",
		hoverClass: "hover",
		focusClass: "focus",
		openClass: "open"
	});
	$('a.sub_nav').removeClass('sub_nav');
	if (is_touch_device() === true) {
	    var pos_options = {
		  enableHighAccuracy: false,
		  timeout: 5000,
		  maximumAge: 50000
		};
		var number_displayed = 5;
		navigator.geolocation.getCurrentPosition(pos_success, pos_error, pos_options);
	}
	else {
	}
}); //End document.ready

window.addEventListener('load', function() {
	var sliderHeight = $('.header_cont').height();
	var headerHeight = 120;
	$(window).scroll(function () {
        var distanceY = window.pageYOffset || document.documentElement.scrollTop,
            shrinkOn = (sliderHeight - headerHeight),
            header = $("#header");
        if (distanceY > shrinkOn) {
            header.addClass("smaller");
        } else {
            header.removeClass("smaller");
        }
    });
}); //End window.load

function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

function pos_success(pos) {
	var current_pos = pos.coords;
	var slongitude = current_pos.longitude;
	var slatitude = current_pos.latitude;
	var current_text = '';
	var driving_link = '';
	$('.driving_directions').each(function(){
		current_text = $(this).text();
		driving_link = '<a class="driving_directions" href="http://maps.google.com/maps?saddr=' + slatitude + ' , ' + slongitude + '&daddr=' + dlatitude + ' , ' + dlongitude + '" target="_blank">' + current_text + '</a>';
		$(this).parent().empty().html(driving_link);
	});

}

function pos_error(err) {
	if(err){
		//var driving_link = '<a href="http://maps.google.com/maps?daddr=' + dlatitude + ' , ' + dlongitude + '" target="_blank">Open map for ' + company_name + '</a>';
	}
}


//Google Analytics Event Tracking
//https://developers.google.com/analytics/devguides/collection/analyticsjs/events
function trackEvent(category, action, label) {
	//EXAMPLES:
	//ga('send', 'event', 'Videos', 'Play', 'Gone With the Wind']);
	//ga('send', 'event', 'Videos', 'Downloaded', 'Gone With the Wind']);
	//ga('send', 'event', 'Downloads', 'PDF', 'Expense Report']);
	//ga('send', 'event', 'datasheet-download', 'click', 'http://www.myurl.com');
	if (typeof ga !== 'undefined') {
		//ga('send', 'event', category, action, label);
		gtag('event', action, {
			// Event parameters
			'event_category': category,
			'event_label': label,
			'send_to' : 'UA-11777234-45'
		});
	} else {
		console.log('Simulating GA event tracking: category = "'+category+'", action = "'+action+'", label = "'+label+'"');
	}
}

function addScrollToOnClick(clickedElm, targetElm, animationDuration) {
	$(clickedElm).click(function(event) {
		event.preventDefault();
		console.log(targetElm);
		$('html, body').animate({scrollTop: $(targetElm).offset().top}, animationDuration);
		return false;
	});
}

/*
 * jQuery getCSS Plugin
 * Copyright 2013, intesso
 * MIT license.
 *
 * cross browser function to dynamically load an external css file.
 * see: [github page](http://intesso.github.com/jquery-getCSS/)
 *
 */

(function() {
	/*
		arguments: attributes
		attributes can be a string: then it goes directly inside the href attribute.
		e.g.: $.getCSS("fresh.css")
		attributes can also be an objcet.
		e.g.: $.getCSS({href:"cool.css", media:"print"})
		or:	$.getCSS({href:"/styles/forest.css", media:"screen"})
	*/
	var getCSS = function(attributes) {
			// setting default attributes
			if(typeof attributes === "string") {
				var href = attributes;
				attributes = {
					href: href
				};
			}
			if(!attributes.rel) {
				attributes.rel = "stylesheet";
			}
			// appending the stylesheet
			// no jQuery stuff here, just plain dom manipulations
			var styleSheet = document.createElement("link");
			for(var key in attributes) {
				styleSheet.setAttribute(key, attributes[key]);
			}
			var head = document.getElementsByTagName("head")[0];
			head.appendChild(styleSheet);
		};

	if(typeof jQuery === "undefined") {
		window.getCSS = getCSS;
	} else {
		jQuery.getCSS = getCSS;
	}

})();